module.exports = __webpack_public_path__ + "img/danye10.b6a13ad6.jpg";